import React from 'react';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
function SkeletonProjectGrid() {
    return (
        <div className="row table-row">
            <div className="col-12">
                <div className="card mt-1">
                    <div className="card-body pb-0">
                        <div className="header d-flex justify-content-between align-items-center flex-wrap mb-1">
                            <div className="d-flex justify-content-between align-items-baseline gap-3">
                                <Skeleton className='mr-2' variant="rectangular" width={35} height={32} />
                                <h4 className='mr-2'> <Skeleton variant="rectangular" width={76} height={21} /></h4>
                            </div>
                        </div>
                        <div className="content" >
                            <div className="flex-column">
                                <h5><Skeleton variant="rectangular" width={128} height={15} /></h5>
                                <label><Skeleton variant="rectangular" width={100} height={15} /></label>
                            </div>
                            <div className="flex-column">
                                <h5><Skeleton variant="rectangular" width={128} height={15} /></h5>
                                <label><Skeleton variant="rectangular" width={100} height={15} /></label>
                            </div>
                            <div className="flex-column">
                                <h5><Skeleton variant="rectangular" width={128} height={15} /></h5>
                                <label><Skeleton variant="rectangular" width={100} height={15} /></label>
                            </div>
                            <div className="flex-column">
                                <h5><Skeleton variant="rectangular" width={128} height={15} /></h5>
                                <label><Skeleton variant="rectangular" width={100} height={15} /></label>
                            </div>
                            <div className="flex-column">
                                <h5><Skeleton variant="rectangular" width={128} height={15} /></h5>
                                <label><Skeleton variant="rectangular" width={100} height={15} /></label>
                            </div>
                            <div className="flex-column">
                                <h5><Skeleton variant="rectangular" width={128} height={15} /></h5>
                                <label><Skeleton variant="rectangular" width={100} height={15} /></label>
                            </div>
                            <div className="flex-column">
                                <h5><Skeleton variant="rectangular" width={128} height={15} /></h5>
                                <label><Skeleton variant="rectangular" width={100} height={15} /></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SkeletonProjectGrid